import React from 'react'
import { connect } from 'react-redux'
import { Modal } from '../../../Components/Modal'
import { FirefoxButton } from '../../AuthFirefox'
import { LoginButton } from '../../AuthGoogle'
import { Form } from '../../AuthNative'
import { Login } from '../Login'


const mapStateToProps = (state, params) => {
  const dict = state.localization.dictionary

  return {
    ...state.login,
    dict:    dict.login,
    message: dict.premium.toUpgradePlease
  }
}

class LoginModalContainer extends React.Component {

  state = {
    isVisible: false,
  }

  doClose = () => {
    this.setState({isVisible: false})
  }

  doOpen = () => {
    this.setState({isVisible: true})
  }

  onSuccess = (response) => {
    this.doClose()
    this.dispatchLoginComplete()
  }

  onError = (error) => {
    this.setState({errorMsg: error.message})
  }

  // Notify global.js that user has logged in
  dispatchLoginComplete = () => {
    let event = document.createEvent('Event');
    event.initEvent('login', true, true);
    document.dispatchEvent(event);
  }

  componentDidMount() {
    document.addEventListener('loginModalShow', this.doOpen, false);
  }

  componentWillUnmount() {
    document.removeEventListener('loginModalShow', this.doOpen, false);
  }

  render() {
    const {
      label,
      dict,
      message,
    } = this.props

    return (
      <Modal
        isVisible={ this.state.isVisible }
        label={ dict.headline }
        onClose={ this.doClose }>
        <Login
          dict={ dict }
          errorHtml={ this.state.errorMsg }
          messageHtml={ message }
          onError={ this.onError }
          onSuccess={ this.onSuccess }
          top={
            <div>
              <LoginButton
                children={ dict.loginGoogle }
                onError={ this.onError }
                onSuccess={ this.onSuccess } />
              <FirefoxButton
                children={ dict.loginFirefox } />
            </div>
          }
          bottom={
            <Form
              onError={ this.onError }
              onSuccess={ this.onSuccess } />
          } />
      </Modal>
    )
  }
}

const ConnectedLoginModalContainer = connect(
  mapStateToProps
)(LoginModalContainer)

export {
  ConnectedLoginModalContainer as LoginModalContainer
}
